import {AxiosCall, CancelTokenSource} from '../axios';

export const importPatients = async (
  clinic_group_id: number | string,
  data: any,
  clinic_id?: number | string
): Promise<any> => {
  let urlParams = '';
  if (clinic_id) {
    urlParams = `?clinic_id=${clinic_id}`;
  }
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/import/patients${urlParams}`,
    data,
    {} as CancelTokenSource,
    300000
  );
};

export const importPatientCopay = async (
  clinic_group_id: number | string,
  data: any,
  clinic_id?: number | string
): Promise<any> => {
  let urlParams = '';
  if (clinic_id) {
    urlParams = `?clinic_id=${clinic_id}`;
  }
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/import/patient-copay${urlParams}`,
    data,
    {} as CancelTokenSource,
    300000
  );
};

export const importInvoices = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  data: any,
  statement_month?: any,
  statement_year?: any,
  override?: boolean
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/import/invoices?statement_month=${statement_month}&statement_year=${statement_year}&override=${override}`,
    data,
    {} as CancelTokenSource,
    300000
  );
};

export const importStatementTypes = async (
  clinic_group_id: number | string,
  clinic_id: number | string,
  data: any
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/import/update-due-notice-type`,
    data,
    {} as CancelTokenSource,
    300000
  );
};

export const importAppointments = async (
  clinic_group_id: number | string,
  data: any,
  clinic_id?: number | string
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/import/appointments`,
    data,
    {} as CancelTokenSource,
    300000
  );
};

export const importVoucherLocationMapping = async (
  clinic_group_id: number | string,
  data: any
  // clinic_id?: number | string
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/import/voucher-meta`,
    data,
    {} as CancelTokenSource,
    300000
  );
};
